'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Registration = exports.RegistrationSuccess = exports.RegistrationConfirm = exports.RegistrationForm = exports.RegistrationHeader = undefined;

var _RegistrationHeader = require('./RegistrationHeader');

Object.defineProperty(exports, 'RegistrationHeader', {
  enumerable: true,
  get: function get() {
    return _RegistrationHeader.RegistrationHeader;
  }
});

var _RegistrationForm = require('./RegistrationForm');

Object.defineProperty(exports, 'RegistrationForm', {
  enumerable: true,
  get: function get() {
    return _RegistrationForm.RegistrationForm;
  }
});

var _RegistrationConfirm = require('./RegistrationConfirm');

Object.defineProperty(exports, 'RegistrationConfirm', {
  enumerable: true,
  get: function get() {
    return _RegistrationConfirm.RegistrationConfirm;
  }
});

var _RegistrationSuccess = require('./RegistrationSuccess');

Object.defineProperty(exports, 'RegistrationSuccess', {
  enumerable: true,
  get: function get() {
    return _RegistrationSuccess.RegistrationSuccess;
  }
});

var _Registration2 = require('./Registration');

var _Registration3 = _interopRequireDefault(_Registration2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Registration = _Registration3.default;


//////////////////
// WEBPACK FOOTER
// ./src/components/Registration/index.js
// module id = 758
// module chunks = 0